import { Toggle } from './ui/Toggle';

interface FinanceResultModeToggleProps {
  completedOnly: boolean;
  onChange: (completedOnly: boolean) => void;
}

export function FinanceResultModeToggle({ completedOnly, onChange }: FinanceResultModeToggleProps) {
  return (
    <div
      className="inline-flex shrink-0 items-center gap-2 rounded-lg border border-border-subtle bg-surface-hover/50 px-3 py-2 text-sm font-medium"
      title="Zrealizowane: zamówienia w statusach wybranych w ustawieniach Finansów."
    >
      <span className={completedOnly ? 'text-text-secondary' : 'text-text-primary'}>
        Szacowane
      </span>
      <Toggle
        size="sm"
        role="switch"
        aria-label="Zrealizowane"
        checked={completedOnly}
        onChange={(event) => onChange(event.target.checked)}
      />
      <span className={completedOnly ? 'text-text-primary' : 'text-text-secondary'}>
        Zrealizowane
      </span>
    </div>
  );
}
